module.exports = __webpack_public_path__ + "1793882494189/fonts/Flaticon.e905df2.woff";